"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  props: ["projectsPageLink", "adminsPageLink", "testManagersPageLink", "testsPageLink", "composedTestsPageLink", "usersPageLink"],

  mixins: [require("../../mixins/UserCan.js")]
};


//////////////////
// WEBPACK FOOTER
// ./~/babel-loader/lib?cacheDirectory!./~/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/menu/MainMenuAdmin.vue
// module id = ol9b
// module chunks = 0 1